module.exports = __webpack_public_path__ + "img/vinExmapleOutlined.e551c8e0.svg";